import { render, staticRenderFns } from "./4mOnePage.vue?vue&type=template&id=197aaeca"
import script from "./4mOnePage.vue?vue&type=script&lang=js"
export * from "./4mOnePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('197aaeca')) {
      api.createRecord('197aaeca', component.options)
    } else {
      api.reload('197aaeca', component.options)
    }
    module.hot.accept("./4mOnePage.vue?vue&type=template&id=197aaeca", function () {
      api.rerender('197aaeca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/4mOnePage.vue"
export default component.exports